import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddAccommodationDialog = _resolveComponent("AddAccommodationDialog")!
  const _component_AdminAccommodations = _resolveComponent("AdminAccommodations")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, { class: "accommodations-table-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_AddAccommodationDialog, { onAccommodationCreated: _ctx.fetchData }, null, 8, ["onAccommodationCreated"]),
        _createVNode(_component_AdminAccommodations, { accommodations: _ctx.accommodations }, null, 8, ["accommodations"])
      ]),
      _: 1
    })
  ]))
}